
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan,
  IFlexMessageText,
  IFlexMessageVideo,
} from '@/utils/types'
import FlexMessageComponents from '@/components/common/flex-message/FlexMessageComponents.vue'
import FlexMessageTreeNodes from '@/components/common/flex-message/FlexMessageTreeNodes.vue'

@Options({
  components: { FlexMessageTreeNodes, FlexMessageComponents },
  directives: { maska },
  emits: ['onSelectNode', 'onHoverNode'],
})
export default class FlexMessageBubbleTree extends Vue {
  @Prop()
  message!: IFlexMessageBubble

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  bubbleIndex!: number

  @Prop()
  errorPath!: string[]

  showBubble = true
  showHeader = true
  showHero = true
  showBody = true
  showFooter = true

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }
}
